
// registrations
export const GET_REGISTRATIONS = "/api/v1/registrations";
export const ADD_NEW_REGISTRATION = "/api/v1/registrations";
export const UPDATE_REGISTRATION = "/api/v1/registrations";
export const DELETE_REGISTRATION = "/api/v1/registrations";


